import { DeepPartial } from 'utility-types';
import {
  Record,
  String as RTString,
  Array as RTArray,
  Static,
  Undefined,
  Null
} from 'runtypes';
import { Customer, PrimaryCustomer } from '../../customer';
import { Beneficiary } from '../../beneficiary';
import { BankAccountReference, BankFailure } from '../../bank-acount';
import { Investment } from '../../investment';

export const JointApplication = Record({
  customer: PrimaryCustomer,
  jointOwners: RTArray(Customer),
  beneficiaries: Beneficiary.Or(Undefined).Or(Null),
  newInvestments: RTArray(Investment),
  investmentMethod: RTString,
  fundingMethodType: RTString,
  bankInformationReference: BankAccountReference.Or(Undefined).Or(Null),
  bankFailureInformation: RTArray(BankFailure)
    .Or(Undefined)
    .Or(Null),
  profileApplicationID: RTString,
  termsIDs: RTArray(RTString),
  deviceToken: RTString
});

export type StaticJointApplication = Static<typeof JointApplication>;
export type OptionalStaticJointApplication = DeepPartial<
  StaticJointApplication
>;
